<app-tree-list
  class="tree-list"
  [items]="items"
  [tooltipEnabled]="false"
  [openedIndicatorAtLeft]="true"
  [openedSingleMode]="false"
>
  <ng-template
    treeItem
    let-item="item"
    let-parentItem="parentItem"
    let-level="level"
  >
    <div
      class="layer-item-content"
      [ngClass]="{
        'not-in-scale': !!item.notInScale,
        'has-icon': !!item.icon,
        'without-indicator-open': !item.openedIndicatorEnabled
      }"
    >
      <app-check-box
        class="checkbox"
        [value]="isItemVisible(item)"
        (valueChange)="onVisibleChange(item, $event, parentItem)"
        (click)="$event.stopPropagation()"
      ></app-check-box>

      <ng-container *ngIf="!!item.icon">
        <svg-icon
          *ngIf="!!item.iconSizeAuto"
          class="icon"
          [src]="item.icon"
        ></svg-icon>

        <app-iconic
          *ngIf="!item.iconSizeAuto"
          class="icon"
          [icon]="item.icon"
          useAs="svg"
        ></app-iconic>
      </ng-container>

      <div
        class="label"
        [ngClass]="{ bold: level === 1 }"
        style="--layer-item-level: {{ level }}"
      >
        {{ item.text ?? item.layer.id }}
      </div>
    </div>

    <div
      class="opacity-slider-container"
      [ngClass]="{ 'has-icon': !!item.icon }"
      *ngIf="hasLayerOpacity(item)"
    >
      <app-range-slider
        class="range-slider"
        [(value)]="item.layer.opacity"
        [min]="0"
        [max]="1"
        [step]="0.01"
        (click)="$event.stopPropagation()"
        [linearColorStopList]="['#CED4DA', '#343A40']"
      ></app-range-slider>
    </div>

    <div
      class="btn-item"
      *ngIf="!!(allowDeleteLayer && !levelsNotAllowedToDelete?.includes(level))"
      #btnDeleteLayerEl
    >
      <app-button
        class="btn-item-content"
        buttonType="danger"
        styleType="text"
        shapeType="circle"
        sizeType="small"
        marginType="icon"
        icon="assets/icons/trash.svg"
        (click)="onBtnDeleteLayerClickInternal($event, item)"
      ></app-button>

      <app-tooltip
        [target]="btnDeleteLayerEl"
        verticalAlignment="top"
        horizontalAlignment="center"
      >
        Apagar camada
      </app-tooltip>
    </div>
  </ng-template>
</app-tree-list>

<ng-template #layerLegendTpl let-item="item">
  <app-legend-layer
    class="legend-layer"
    [ngClass]="{
      'with-indicator-open': item.openedIndicatorEnabled && item.hasItems
    }"
    [mapView]="mapView"
    [layer]="item.layer"
  ></app-legend-layer>
</ng-template>

<app-loading-panel
  [visible]="!!(loadingVisibleObservable | async)"
  [container]="elementRef.nativeElement"
  [overlayMask]="true"
></app-loading-panel>
